import { render } from "./ProfilView.vue?vue&type=template&id=179f7d52&scoped=true"
import script from "./ProfilView.vue?vue&type=script&lang=js"
export * from "./ProfilView.vue?vue&type=script&lang=js"

import "./ProfilView.vue?vue&type=style&index=0&id=179f7d52&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179f7d52"]])

export default __exports__